import { render, staticRenderFns } from "./sysMessage.vue?vue&type=template&id=209a1ef3&scoped=true"
import script from "./sysMessage.vue?vue&type=script&lang=js"
export * from "./sysMessage.vue?vue&type=script&lang=js"
import style0 from "./sysMessage.vue?vue&type=style&index=0&id=209a1ef3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a1ef3",
  null
  
)

export default component.exports